import type { CustomerActivityItem } from '@/api/services/customerActivity';

export type ActivityChipVariant = 'default' | 'sent' | 'skipped' | 'failed' | 'new';

export function resolveActivityChipVariant(item: CustomerActivityItem): ActivityChipVariant {
  const type = (item.type || '').toLowerCase();
  if (!item.read) return 'new';
  if (type.includes('skipped') || item.severity === 'warning') return 'skipped';
  if (type.includes('failed') || item.severity === 'error' || item.severity === 'critical') {
    return 'failed';
  }
  if (type.includes('sent') || item.severity === 'success') return 'sent';
  return 'default';
}

export function formatActivityCategoryLabel(category: string): string {
  const trimmed = category.trim();
  if (!trimmed) return 'ACTIVITY';
  return trimmed.toUpperCase();
}

export function buildActivityMetaLine(item: CustomerActivityItem, timeLabel: string): string {
  const parts: string[] = [timeLabel];
  const searchName = item.search?.name || item.search?.title;
  if (searchName) parts.push(String(searchName));
  const recipient = item.recipient?.name;
  if (recipient) parts.push(String(recipient));
  const actor = item.actor?.name || item.actor?.email;
  if (actor) parts.push(String(actor));
  return parts.filter(Boolean).join(' · ');
}
